<template>
  <UiPopover v-model:aperto="aperto" :aria-label="t('centro_notifiche.titolo')" allineamento="fine">
    <template #trigger="{ attributi, alterna }">
      <button
        type="button"
        v-bind="attributi"
        class="interactive focusable relative inline-flex h-10 shrink-0 cursor-pointer items-center justify-center gap-1.5 rounded-full border border-border-strong bg-glass-strong text-text-primary after:absolute after:-inset-1 after:content-['']"
        :class="store.nonLette > 0 ? 'pr-2 pl-3' : 'w-10'"
        :aria-label="t('centro_notifiche.campanella', { n: store.nonLette }, store.nonLette)"
        data-test="campanella"
        @click="alterna"
      >
        <i class="fal fa-bell" aria-hidden="true" />
        <span v-if="store.nonLette > 0" class="inline-flex min-w-5 items-center justify-center rounded-full bg-accent px-1.5 py-0.5 text-xs leading-none font-semibold text-on-accent" data-test="campanella-numero">{{ store.nonLette > 9 ? "9+" : store.nonLette }}</span>
      </button>
    </template>
    <NotificheTendina v-if="aperto" @chiudi="aperto = false" />
  </UiPopover>
</template>

<script setup lang="ts">
// Campanella della barra globale: il numero delle notifiche non lette (da 1 a 9, poi «9+») sta accanto all'icona, per notarsi in mezzo agli altri controlli. Al clic apre la
// tendina con le ultime. Il numero si rilegge ogni minuto a scheda visibile (e a ogni lettura o archiviazione); il tempo reale arriva con le notifiche generate dal server.
import { useI18n } from "vue-i18n";

const INTERVALLO_MS = 60_000;
const { t } = useI18n();
const store = useNotificheStore();
const aperto = ref(false);

// `useRichiesta` dà il polling che non si sovrappone e si ferma a scheda nascosta; il valore sta nello store
useRichiesta(async () => {
  await store.aggiorna();
  return store.nonLette;
}, { intervallo: INTERVALLO_MS });
</script>
